import { useEffect, useState } from 'react'
import clsx from 'clsx'

import { Popup } from '@/ui/Popup'
import styles from './DateInput.module.scss'
import ArrowIcon from '../assets/arrow.svg'
import { formatDate } from '../utils/formatDate'
import { useDateStore } from '../store'
import { DatePickerPM } from '@/ui/DatePicker'

const POPUP_OFFSET = 12

export const DateInputPM = ({ isIndexPage }: { isIndexPage?: boolean }) => {
    const { date, setDate } = useDateStore()
    const [selectedDate, setSelectedDate] = useState(date ? new Date(date) : new Date())

    const handleDateChange = (date: Date) => {
        setSelectedDate(date)
        setDate(date)
    }

    useEffect(() => {
        setSelectedDate(new Date(date))
    }, [date])

    return (
        <Popup
            offset={POPUP_OFFSET}
            placement="bottom-start"
            className={styles.popup}
            triggerComponent={(isOpen) => (
                <div className={styles.selectContainer}>
                    <span className={styles.label}>{formatDate(selectedDate)}</span>
                    <button className={clsx(styles.triggerButton, { [styles.open]: isOpen })}>
                        <ArrowIcon />
                    </button>
                </div>
            )}
        >
            <DatePickerPM value={selectedDate} onChange={handleDateChange} isIndexPage={isIndexPage} />
        </Popup>
    )
}
